import { render, staticRenderFns } from "./teamSharePer.vue?vue&type=template&id=70e20ea8&scoped=true"
import script from "./teamSharePer.vue?vue&type=script&lang=js"
export * from "./teamSharePer.vue?vue&type=script&lang=js"
import style0 from "./teamSharePer.vue?vue&type=style&index=0&id=70e20ea8&prod&scoped=true&lang=css"
import style1 from "./teamSharePer.vue?vue&type=style&index=1&id=70e20ea8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e20ea8",
  null
  
)

export default component.exports